export default {

  isAuthenticated(state, data) {
    state.isAuthenticated = data;
  },
  uId(state, data) {
    state.uId = data;
  },
  token(state, data) {
    state.token = data;
  },

  today(state, data) {
    state.today = data;
  },
  todayActual(state, data) {
    state.todayActual = data;
  },
  tomorrowActual(state, data) {
    state.tomorrowActual = data;
  },
  todaysDateDisplay(state, data) {
    state.todaysDateDisplay = data;
  },
  dayOfWeek(state, data) {
    state.dayOfWeek = data;
  },

  reasons(state, data) {
    state.reasons = data;
  },
  program(state, data) {
    state.program = data;
  },




  
  /**
   * do i actually use these? yes, but the way i'm using it is wrong. should/shall be cleaned up later
   */
  setUser(state, data) {
    state.uId = data.uId;
    state.token = data.token;
    state.isAuthenticated = true;
    state.didAutoSignout = false;
  },
  setAutoSignout(state) {
    state.didAutoSignout = true;
  },
};
